import { render } from "./Settlements.vue?vue&type=template&id=d3a8e168&scoped=true"
import script from "./Settlements.vue?vue&type=script&lang=js"
export * from "./Settlements.vue?vue&type=script&lang=js"

import "./Settlements.vue?vue&type=style&index=0&id=d3a8e168&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3a8e168"]])

export default __exports__